import React from 'react';
import { LayerGroup, LayersControl, WMSTileLayer } from 'react-leaflet';
import VectorGridC from '../VectorGridC';

const { Overlay } = LayersControl

export class OSLayers {

    static getMapLayers(t, orgLayers) {
        const configuredMapLayers = orgLayers;

        let mapLayers = [];
        if (configuredMapLayers != null && configuredMapLayers.some(s => s.layer === "os_data_overlay")) {
            mapLayers.push(
                <Overlay name={t("map.os_highways")}>
                    <LayerGroup>
                        <VectorGridC
                            key="os_highways"
                            tileLayerName="os_highways"
                            layerStyle="os_highways"
                            url={"/maps/os/vector/highways/{z}/{y}/{x}.pbf"}
                            minZoom={15}
                        />
                    </LayerGroup>
                </Overlay>
            )

            mapLayers.push(
                <Overlay name={t("map.os_greenspace")}>
                    <LayerGroup>
                        <VectorGridC
                            key="os_greenspace"
                            tileLayerName="os_greenspace"
                            layerStyle="os_greenspace"
                            url={"/maps/os/vector/greenspace/{z}/{y}/{x}.pbf"}
                            minZoom={15}
                        />
                    </LayerGroup>
                </Overlay>
            )

            mapLayers.push(
                <Overlay name={t("map.os_boundaries")}>
                    <LayerGroup>
                        <VectorGridC
                            key="os_boundaries"
                            tileLayerName="os_boundaries"
                            layerStyle="os_boundaries"
                            url={"/maps/os/vector/boundaries/{z}/{y}/{x}.pbf"}
                            minZoom={15}
                        />
                    </LayerGroup>
                </Overlay>
            )

            mapLayers.push(
                <Overlay name={t("map.os_sites")}>
                    <LayerGroup>
                        <VectorGridC
                            key="os_sites"
                            tileLayerName="os_sites"
                            layerStyle="os_sites"
                            url={"/maps/os/vector/sites/{z}/{y}/{x}.pbf"}
                            minZoom={15}
                        />
                    </LayerGroup>
                </Overlay>
            )

            mapLayers.push(
                <Overlay name={t("map.os_water")}>
                    <LayerGroup>
                        <VectorGridC
                            key="os_water"
                            tileLayerName="os_water"
                            layerStyle="os_water"
                            url={"/maps/os/vector/water/{z}/{y}/{x}.pbf"}
                            minZoom={15}
                        />
                    </LayerGroup>
                </Overlay>
            )

        }

        return mapLayers;
    }

}